import React, { useEffect, useRef, useState,useContext } from "react";
import {
  Grid,
  TextField,
  Typography,
  Paper,
  Switch,
  FormControlLabel,
  Container,
  Box,
  TextareaAutosize,
  Button,
  FormGroup,
  CircularProgress,
} from "@mui/material";
import { MapContainer, TileLayer, Marker } from "react-leaflet";
import L, { setOptions } from "leaflet";
import Textarea from "@mui/joy/Textarea";
import "leaflet/dist/leaflet.css";
import LocationMarker from "../ui/Map";
import Dropdown from "../ui/Dropdown";
import { ImageIcon, VideoIcon, ImageUp, MonitorUp } from "lucide-react";
import { Mutation, useMutation, useMutationState } from "@tanstack/react-query";
import { postRealEstateData, useFetchData } from "../hooks/useFetchData";
import { useTranslation } from "react-i18next";
import ModalUnstyled from "../ui/Modal";
import Modall from "../ui/Modal";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { redirect, useNavigate } from "react-router-dom";
import { formSchemaa, validationSchema } from "./validation";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import CustomerTestimonial from "../ui/Loading";
import { ToastContainer, toast } from "react-toastify";
import customIconUrl from './images/home.png'; // Replace with your actual image path
import { usecontextUser } from "../context/usecontextUser";


let DefaultIcon = L.icon({
    iconUrl: customIconUrl,
    // shadowUrl: iconShadow,
    iconSize: [60, 60],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    // shadowSize: [41, 41],
  });
export default function Addnew() {
    const {user} =useContext(usecontextUser)
  
  L.Marker.prototype.options.icon = DefaultIcon;
  const { data: dataa } = useFetchData(
    "https://3dfinal.tanaghomtech.com/public/api/categories"
  );
  const { data: data2 } = useFetchData(
    "https://3dfinal.tanaghomtech.com/public/api/cities"
  );
  console.log("data2", data2);

  const { t } = useTranslation();
  const navigate = useNavigate();
  const [markerPosition, setMarkerPosition] = useState({
    lat: 33.51328081312661,
    lng: 36.27681196925691,
  });
    const [userid, setUserid] = useState(user.id);
  
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [preview, setPreview] = useState(null);
  const [previeww, setPrevieww] = useState(null);
  const [preview2, setPreview2] = useState(null);
  const [previeww2, setPrevieww2] = useState(null);
  const [previews, setPreviews] = useState([]);
  const [previewss, setPreviewss] = useState([]);
  const [previewsV, setPreviewsV] = useState([]);
  const [previewssV, setPreviewssV] = useState([]);
  const [checked, setChecked] = useState({});
  const [formDataa, setFormDataa] = useState({});
  const [open, setOpen] = useState();
  const [categorytype, setCategorytype] = useState([]);
  const [citytype, setCitytype] = useState([]);
  const [imageError, setImageError] = useState();
  const im = process.env.REACT_APP_IMAGE;
  const fileInputRef = useRef();
  const openFilePicker = () => {
    fileInputRef.current?.click();
  };
  const [rent, setRent] = useState(null);
  const [unit, setUnit] = useState(null);
  const {
    register,
    handleSubmit,
    formState: { errors },
    trigger,
    watch,
    getValues,
    control,
    setValue,
  } = useForm({
    resolver: yupResolver(formSchemaa, validationSchema),
  });

  const handleDropdownChange = (label, value) => {
    if (label === "Offer type") {
      setUnit(value); // Update the rent state
    }
  };
  const handleDropdownChange2 = (label, value) => {
    if (label === "unit status") {
      setRent(value); // Update the rent state
    } else if (label === "Category type") {
      const selectedCategory = dataa?.data?.find((item) => item.id === value);
      setCategorytype(selectedCategory);
      console.log("selectedCategory", selectedCategory);
    } else if (label === "Cities") {
      const selectedCity = data2?.data?.find((item) => item.id === value);
      setCitytype(selectedCity);
      console.log(
        "selectedCity",
        data2?.data?.find((item) => item.id === value)
      );
    }
  };

  useEffect(() => {
    handleDropdownChange();
    console.log(typeof unit, unit);
    handleDropdownChange2();
    console.log(typeof rent, rent);
  }, [unit, rent]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (value !== undefined) {
      setFormDataa((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };
  const handleswitch = (e) => {
    const { name, checked: isChecked } = e.target;
    setChecked((prev) => ({
      ...prev,
      [name]: isChecked,
    }));
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith("image/")) {
      setPreview(URL.createObjectURL(file));
      console.log(im);
      trigger("unit_image");
      setValue("unit_image", file, { shouldValidate: true });
      setPrevieww(file);
    }
  };
  const handleImageUpload2 = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith("image/")) {
      setPreview2(URL.createObjectURL(file));
      setPrevieww2(file);
    }
  };

  const handleImageUploadvideo = (event) => {
    const files = Array.from(event.target.files);

    // ✅ Filter only video files
    const videoFiles = files.filter((file) => file.type.startsWith("video/"));
    const videoPreviews = videoFiles.map((file) => URL.createObjectURL(file));
    setPreviewssV(videoFiles); // ✅ use this in rendering
    setPreviewsV((prev) => [...prev, ...videoPreviews]); // add new previews to existing ones
  };

  const handleImageUploads = (e, onChange) => {
    const files = Array.from(e.target.files); // convert FileList to an array
    onChange(files);
    const totalImages = previews.length + files.length;
    if (totalImages > 10) {
      setImageError("You can only upload a maximum of 3 images.");
      return;
    }
    if (totalImages < 3) {
      setImageError("You must upload  3 images.");
      return;
    }
    setImageError("");
    setValue("images", files, { shouldValidate: true });
    trigger("images");
    if (files.length === 0) {
      setPreviews([]);
      return;
    }
    const validImages = files.filter((file) => file.type.startsWith("image/"));
    const imagePreviews = validImages.map((file) => URL.createObjectURL(file));
    setPreviewss(files);
    setPreviews((prev) => [...prev, ...imagePreviews]);
  };

  const mutation = useMutation({
    mutationFn: postRealEstateData,
    onSuccess: (data) => {
      console.log("Posted successfully", data.data.post.post_reference);
      setData(data.data.post.post_reference);
    },
    onError: (error) => {
      console.error("Posting failed", error.message);
    },
  });

  const handleOpen = async () => {
    const valid = await trigger([
      "status_id",
      "offertype_id",
      "address",
      "description",
      "total_area",
      "price",
      "images",
      "unit_image",
    ]);
    if (valid) {
      setOpen(true);
    } else {
      toast.error("complete all required input");
    }
  };

  const handleSubmitt = () => {
    if (!previeww) {
      toast.error(t("AddUnit.mainimage2"));
    }

    if (previewss.length < 3) {
      toast.error(t("AddUnit.least32"));
    }
    setLoading(true);
    const formData = new FormData();

    // Append coordinates
    formData.append("latitude", markerPosition.lat);
    formData.append("longitude", markerPosition.lng);
    formData.append("user_id", userid);
    const formValues = getValues();
    Object.entries(formValues).forEach(([key, value]) => {
      if (value !== undefined && value !== "") {
        formData.append(key, value);
      }
    });
    Object.entries(checked).forEach(([key, value]) => {
      formData.append(key, value ? 1 : 0);
      console.log(key, value);
    });

    formData.append("unit_image", watch("unit_image"));
    if (previeww2) {
      formData.append("unit_plan", previeww2);
      toast("hiii");
    }

    // Append other images
    previewss.forEach((file) => {
      formData.append("images[]", file);
    });
    previewssV.forEach((file) => {
      formData.append("videos[]", file);
    });
    formSchemaa
      .validate(formData, { abortEarly: false })
      .then((validData) => {
        console.log("Valid!", validData);
        // Proceed to send validData to backend
      })
      .catch((validationError) => {
        console.log("notValid!", validationError);
      });
    console.log(formData);

    // Call mutation
    mutation.mutate(formData, {
      onSuccess: (data) => {
        setLoading(false);
        navigate(`/finished/${data.data.post.post_reference}`);
        console.log("Success!");
      },
      onError: (error) => {
        setLoading(false); // Stop loading on error
        toast(error.message);
        console.error("Error occurred");
      },
    });
  };

  return (
    <form onSubmit={handleSubmit(handleSubmitt)}>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "100px",
          }}
        >
          <CustomerTestimonial />
        </div>
      ) : (
        <Container sx={{ overflowY: "auto", mb: 10 }}>
          <Paper
            elevation={10}
            style={{
              backgroundColor: "#fff",
              padding: 0,
              borderRadius: 16,
              marginTop: 16,
              direction: t("directions.dir"),
            }}
          >
            <Typography
              variant="h4"
              sx={{
                mt: 2,
                mb: 2,
                boxShadow:
                  "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
                padding: "8px",
                backgroundColor: "#f3efee",
                display: "inline-block",
                width: "auto",
                fontWeight: "bold",
                fontFamily: "oswald,cairo",
                //   right:'0',
                //   position:'absolute'
              }}
            >
              {t("AddUnit.Step1")}
            </Typography>
            <div style={{ padding: "24px" }}>
              <Box
                sx={{
                  width: "100%",
                  gap: 2,
                  maxWidth: "100%",
                  display: "flex",
                  mb: 3,
                }}
              >
                <ToastContainer />
                <Controller
                  name="status_id"
                  control={control}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      label={t("AddUnit.unitstatus")}
                      url="unitstatus"
                      value={field.value} // Bind field value
                      onChange={(value) => {
                        field.onChange(value); // Update form state
                        handleDropdownChange("unit status", value); // Update external state
                        setUnit(value); // Update unit state
                      }}
                      error={!!fieldState.error} // Error handling
                      helperText={fieldState.error?.message} // Error message display
                    />
                  )}
                />

                <Controller
                  name="category_id"
                  control={control}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      label={t("AddUnit.category")}
                      url="categories"
                      value={field.value}
                      onChange={(value) => {
                        field.onChange(value); // Update form state
                        handleDropdownChange2("Category type", value); // Update rent state
                        setRent(value);
                      }}
                      error={!!fieldState.error}
                      helperText={fieldState.error?.message}
                    />
                  )}
                />
                {categorytype && (
                  <Controller
                    name="offertype_id"
                    control={control}
                    render={({ field, fieldState }) => (
                      <Dropdown
                        options={categorytype?.offertypes || []}
                        label={t("AddUnit.unitType")}
                        value={field.value}
                        onChange={(value) => {
                          field.onChange(value); // Update form state
                          handleDropdownChange2("Offer type", value); // Update rent state
                          setRent(value);
                        }}
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                      />
                    )}
                  />
                )}
              </Box>
              <Grid item xs={12} sx={{ mb: 3 }}>
                <Typography
                  sx={{ fontFamily: "oswald,cairo" }}
                  variant="h5"
                  gutterBottom
                >
                  {t("AddUnit.map")}
                </Typography>
                <MapContainer
                  center={[markerPosition.lat, markerPosition.lng]}
                  zoom={13}
                  style={{ height: 400, borderRadius: 10 }}
                >
                  <TileLayer
                    attribution="&copy; OpenStreetMap contributors"
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  />
                  <LocationMarker
                    position={markerPosition}
                    setPosition={setMarkerPosition}
                  />
                </MapContainer>
              </Grid>
              <Box
                sx={{
                  width: "100%",
                  gap: 2,
                  maxWidth: "100%",
                  display: "flex",
                  mb: 3,
                }}
              >
                <Controller
                  name="contract_id"
                  control={control}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      label={t("AddUnit.contract")}
                      url="contracts"
                      value={field.value}
                      onChange={field.onChange}
                      error={!!fieldState.error}
                      helperText={fieldState.error?.message}
                    />
                  )}
                />{" "}
                <Controller
                  name="city_id"
                  control={control}
                  rules={{ required: "City is required" }}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      label={t("AddUnit.Cities")}
                      url="cities"
                      value={field.value}
                      onChange={(value) => {
                        field.onChange(value);
                        handleDropdownChange2("Cities", value);
                      }}
                      error={!!fieldState.error}
                      helperText={fieldState.error?.message}
                    />
                  )}
                />
                {citytype && (
                  <Controller
                    name="region_id"
                    control={control}
                    rules={{ required: "region is required" }}
                    render={({ field, fieldState }) => (
                      <Dropdown
                        options={citytype?.regions || []}
                        label={t("AddUnit.region")}
                        value={field.value}
                        onChange={field.onChange}
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                      />
                    )}
                  />
                )}
              </Box>
              <Box
                sx={{
                  width: "100%",
                  gap: 2,
                  maxWidth: "100%",
                  display: "flex",
                  mb: 3,
                }}
              >
                <TextField
                  fullWidth
                  {...register("address")}
                  id="fullWidth"
                  name="address"
                  value={formDataa.address || ""}
                  onChange={handleChange}
                  label={
                    <span style={{ display: "flex", alignItems: "center" }}>
                      {t("AddUnit.address")}{" "}
                      <span
                        style={{
                          color: "red",
                          fontSize: "25px",
                          marginBottom: "-5px",
                        }}
                      >
                        *
                      </span>
                    </span>
                  }
                  error={!!errors.address}
                  helperText={errors.address?.message}
                />
                <TextField
                  fullWidth
                  onChange={handleChange}
                  value={formDataa.address_en || ""}
                  label={
                    <span style={{ display: "flex", alignItems: "center" }}>
                      {t("AddUnit.address_en")}{" "}
                      <span
                        style={{
                          color: "red",
                          fontSize: "25px",
                          marginBottom: "-5px",
                        }}
                      ></span>
                    </span>
                  }
                  id="fullWidth"
                  name="address_en"
                />
              </Box>
              <Box sx={{ mb: 2 }}>
                <label
                  htmlFor="description"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    fontWeight: "400",
                    color: "gray",
                  }}
                >
                  {t("AddUnit.description")}{" "}
                  <span
                    style={{ color: "red", fontSize: "20px", marginLeft: 4 }}
                  >
                    *
                  </span>
                </label>
                <label
                  style={{
                    fontWeight: "300",
                    fontWeight: "300",
                    color: "gray",
                  }}
                >
                  {t("AddUnit.least100")}
                </label>
                <Textarea
                  id="description"
                  name="description"
                  minRows={4}
                  size="lg"
                  {...register("description")}
                  error={!!errors.description}
                  value={formDataa.description || ""}
                  onChange={handleChange}
                />
                {errors.description && (
                  <Typography variant="caption" color="error">
                    {errors.description.message}
                  </Typography>
                )}

                {/* {formErrors?.description && (
                                    <p style={{ color: 'red', fontSize: '0.8rem', marginTop: '4px' }}>
                                        {formErrors.description}
                                    </p>
                                )} */}

                <Box sx={6}></Box>
              </Box>
              <Box sx={12}>
                <label style={{ fontWeight: "400", color: "gray" }}>
                  {t("AddUnit.description_en")}
                </label>
                <Textarea
                  xs={5}
                  minRows={4}
                  {...register("description_en")}
                  size="lg"
                  label="description_en"
                  name="description_en"
                  value={formDataa.description_en || ""}
                  onChange={handleChange}
                />
                <p>{errors.description_en?.message}</p>
                <Box sx={6}></Box>
              </Box>
            </div>
          </Paper>
          <Paper
            elevation={10}
            style={{
              backgroundColor: "#fff",
              padding: 0,
              borderRadius: 16,
              marginTop: 16,
              direction: t("directions.dir"),
            }}
          >
            <Typography
              variant="h4"
              sx={{
                mt: 2,
                mb: 2,
                boxShadow:
                  "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
                padding: "8px",
                backgroundColor: "#f3efee",
                display: "inline-block",
                width: "auto",
                fontWeight: "bold",
                fontFamily: "oswald,cairo",
                //   right:'0',
                //   position:'absolute'
              }}
            >
              {t("AddUnit.Step2")}
            </Typography>
            <div style={{ padding: "24px" }}>
              <Box
                sx={{
                  width: "100%",
                  gap: 2,
                  maxWidth: "100%",
                  display: "flex",
                  mb: 3,
                }}
              >
                <Controller
                  name="direction_id"
                  control={control}
                  rules={{ required: "Direction is required" }}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      label={t("AddUnit.direction")}
                      url="directions"
                      value={field.value}
                      onChange={field.onChange}
                      error={!!fieldState.error}
                      helperText={fieldState.error?.message}
                    />
                  )}
                />
                {rent !== 5 && rent !== 8 && rent !== 6 && (
                  <Controller
                    name="condition_id"
                    control={control}
                    rules={{ required: "condition is required" }}
                    render={({ field, fieldState }) => (
                      <Dropdown
                        label={t("AddUnit.condition")}
                        url="conditions"
                        value={field.value}
                        onChange={field.onChange}
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                      />
                    )}
                  />
                )}
                {rent !== 4 && rent !== 5 && rent !== 6 && (
                  <Controller
                    name="furnishing_id"
                    control={control}
                    rules={{ required: "condition is required" }}
                    render={({ field, fieldState }) => (
                      <Dropdown
                        label={t("AddUnit.Furnishing")}
                        url="furnishings"
                        value={field.value}
                        onChange={field.onChange}
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                      />
                    )}
                  />
                )}
              </Box>
              <Box
                sx={{
                  width: "100%",
                  gap: 2,
                  maxWidth: "100%",
                  display: "flex",
                  mb: 3,
                }}
              >
                <TextField
                  fullWidth
                  label={
                    <span style={{ display: "flex", alignItems: "center" }}>
                      {t("AddUnit.totalarea")}{" "}
                      <span
                        style={{
                          color: "red",
                          fontSize: "25px",
                          marginBottom: "-5px",
                        }}
                      >
                        *
                      </span>
                    </span>
                  }
                  {...register("total_area")}
                  id="fullWidth"
                  name="total_area"
                  value={formDataa.total_area || ""}
                  onChange={handleChange}
                  error={!!errors.total_area}
                  helperText={errors.total_area?.message}
                />

                <TextField
                  fullWidth
                  label={
                    <span style={{ display: "flex", alignItems: "center" }}>
                      {t("AddUnit.netarea")}{" "}
                      <span
                        style={{
                          color: "red",
                          fontSize: "25px",
                          marginBottom: "-5px",
                        }}
                      >
                        *
                      </span>
                    </span>
                  }
                  {...register("net_area")}
                  id="fullWidth"
                  name="net_area"
                  value={formDataa.net_area || ""}
                  onChange={handleChange}
                  error={!!errors.net_area}
                  helperText={errors.net_area?.message}
                />

                {rent !== 5 && rent !== 8 && rent !== 1 && (
                  <TextField
                    fullWidth
                    label={
                      <span style={{ display: "flex", alignItems: "center" }}>
                        {t("AddUnit.floorCount")}{" "}
                        <span
                          style={{
                            color: "red",
                            fontSize: "25px",
                            marginBottom: "-5px",
                          }}
                        >
                          *
                        </span>
                      </span>
                    }
                    {...register("floor_number")}
                    id="fullWidth"
                    name="floor_number"
                    value={formDataa.floor_number || ""}
                    onChange={handleChange}
                    error={!!errors.floor_number}
                    helperText={errors.floor_number?.message}
                  />
                )}
                <TextField
                  fullWidth
                  {...register("price")}
                  label={
                    <span style={{ display: "flex", alignItems: "center" }}>
                      {t("AddUnit.price")}{" "}
                      <span
                        style={{
                          color: "red",
                          fontSize: "25px",
                          marginBottom: "-5px",
                        }}
                      >
                        *
                      </span>
                    </span>
                  }
                  id="fullWidth"
                  name="price"
                  value={formDataa.price || ""}
                  onChange={handleChange}
                  error={!!errors.price}
                  helperText={errors.price?.message}
                />
              </Box>
              <Box
                sx={{
                  width: "100%",
                  gap: 2,
                  maxWidth: "100%",
                  display: "flex",
                  mb: 3,
                }}
              >
                {rent !== 5 && rent !== 8 && rent !== 6 && rent !== 2 && (
                  <Controller
                    name="floor_id"
                    control={control}
                    rules={{ required: "condition is required" }}
                    render={({ field, fieldState }) => (
                      <Dropdown
                        label={t("AddUnit.floorid")}
                        url="floors"
                        value={field.value}
                        onChange={field.onChange}
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                      />
                    )}
                  />
                )}

                <Controller
                  name="seller_id"
                  control={control}
                  rules={{ required: "condition is required" }}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      label={t("AddUnit.sellertype")}
                      url="sellertypes"
                      value={field.value}
                      onChange={field.onChange}
                      error={!!fieldState.error}
                      helperText={fieldState.error?.message}
                    />
                  )}
                />

                {unit !== 1 && (
                  <Controller
                    name="rent_id"
                    control={control}
                    rules={{ required: "condition is required" }}
                    render={({ field, fieldState }) => (
                      <Dropdown
                        label={t("AddUnit.rentduration")}
                        url="rentdurations"
                        value={field.value}
                        onChange={field.onChange}
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                      />
                    )}
                  />
                )}
              </Box>
              <Box
                sx={{
                  width: "100%",
                  gap: 2,
                  maxWidth: "100%",
                  display: "flex",
                  mb: 3,
                }}
              >
                {rent !== 5 && rent !== 8 && rent !== 6 && (
                  <TextField
                    fullWidth
                    {...register("rooms_count")}
                    label={t("AddUnit.rooms")}
                    id="fullWidth"
                    name="rooms_count"
                    value={formDataa.rooms_count || ""}
                    onChange={handleChange}
                  />
                )}
                {rent !== 5 && rent !== 8 && rent !== 6 && (
                  <TextField
                    {...register("bath_count")}
                    fullWidth
                    label={t("AddUnit.baths")}
                    id="fullWidth"
                    name="bath_count"
                    value={formDataa.bath_count || ""}
                    onChange={handleChange}
                  />
                )}
              </Box>
              <Box
                sx={{
                  width: "100%",
                  gap: 2,
                  maxWidth: "100%",
                  display: "flex",
                  mb: 3,
                }}
              ></Box>
            </div>
          </Paper>
          <Paper
            elevation={10}
            style={{
              padding: 0,
              borderRadius: 16,
              marginTop: 16,
              display: "flex",
            }}
          >
            <Box
              sx={{
                width: "100%",
                gap: 2,
                maxWidth: "100%",
                mb: 3,
                direction: t("directions.dir"),
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  mt: 2,
                  mb: 2,
                  boxShadow:
                    "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
                  padding: "8px",
                  backgroundColor: "#f3efee",
                  display: "inline-block",
                  width: "auto",
                  fontWeight: "bold",
                  fontFamily: "oswald,cairo",
                  //   right:'0',
                  //   position:'absolute'
                }}
              >
                {t("AddUnit.Step3")}
              </Typography>
              <FormGroup sx={{ padding: "16px" }}>
                <Grid container spacing={2}>
                  <Grid size={4}>
                    <FormControlLabel
                      control={
                        <Switch
                          name="elevator"
                          checked={checked.elevator}
                          onChange={handleswitch}
                        />
                      }
                      label={
                        <Typography
                          sx={{ fontFamily: "Oswald,Cairo" }}
                          fontSize={15}
                        >
                          {t("AddUnit.elevator")}
                        </Typography>
                      }
                    />
                  </Grid>
                  <Grid size={4}>
                    <FormControlLabel
                      control={
                        <Switch
                          name="garden"
                          checked={checked.garden}
                          onChange={handleswitch}
                        />
                      }
                      label={
                        <Typography
                          sx={{ fontFamily: "Oswald,Cairo" }}
                          fontSize={15}
                        >
                          {t("AddUnit.graden")}
                        </Typography>
                      }
                    />
                  </Grid>
                  <Grid size={4}>
                    <FormControlLabel
                      control={
                        <Switch
                          name="terrace"
                          checked={checked.terrace}
                          onChange={handleswitch}
                        />
                      }
                      label={
                        <Typography
                          sx={{ fontFamily: "Oswald,Cairo" }}
                          fontSize={15}
                        >
                          {t("AddUnit.tarrace")}
                        </Typography>
                      }
                    />
                  </Grid>

                  <Grid size={4}>
                    <FormControlLabel
                      control={
                        <Switch
                          name="pool"
                          checked={checked.pool}
                          onChange={handleswitch}
                        />
                      }
                      label={
                        <Typography
                          sx={{ fontFamily: "Oswald,Cairo" }}
                          fontSize={15}
                        >
                          {t("AddUnit.pool")}
                        </Typography>
                      }
                    />
                  </Grid>

                  <Grid size={4}>
                    <FormControlLabel
                      control={
                        <Switch
                          name="barking"
                          checked={checked.barking}
                          onChange={handleswitch}
                        />
                      }
                      label={
                        <Typography
                          sx={{ fontFamily: "Oswald,Cairo" }}
                          fontSize={15}
                        >
                          {t("AddUnit.parking")}
                        </Typography>
                      }
                    />
                  </Grid>
                  <Grid size={4}>
                    <FormControlLabel
                      control={
                        <Switch
                          name="balcony"
                          sx={{ fontSize: "30px" }}
                          checked={checked.balcony}
                          onChange={handleswitch}
                        />
                      }
                      label={
                        <Typography
                          sx={{ fontFamily: "Oswald,Cairo" }}
                          fontSize={15}
                        >
                          {t("AddUnit.balcony")}
                        </Typography>
                      }
                    />
                  </Grid>
                  {/* <Grid size={4}>
                    <FormControlLabel
                      control={
                        <Switch
                          name="elevator"
                          checked={checked.elevator}
                          onChange={handleswitch}
                        />
                      }
                      label={
                        <Typography sx={{fontFamily:"Oswald,Cairo"}} fontSize={15}>{t("AddUnit.elevator")}</Typography>
                      }
                    />
                  </Grid> */}
                  <Grid size={4}>
                    <FormControlLabel
                      control={
                        <Switch
                          name="solar_electricity"
                          checked={checked.solar_electricity}
                          onChange={handleswitch}
                        />
                      }
                      label={
                        <Typography
                          sx={{ fontFamily: "Oswald,Cairo" }}
                          fontSize={15}
                        >
                          {t("AddUnit.solarelectrecity")}
                        </Typography>
                      }
                    />
                  </Grid>

                  <Grid size={4}>
                    <FormControlLabel
                      control={
                        <Switch
                          name="solar_water"
                          checked={checked.solar_water}
                          onChange={handleswitch}
                        />
                      }
                      label={
                        <Typography
                          sx={{ fontFamily: "Oswald,Cairo" }}
                          fontSize={15}
                        >
                          {t("AddUnit.solarwater")}
                        </Typography>
                      }
                    />
                  </Grid>
                  <Grid size={4}>
                    <FormControlLabel
                      control={
                        <Switch
                          name="solar_elevator"
                          checked={checked.solar_elevator}
                          onChange={handleswitch}
                        />
                      }
                      label={
                        <Typography
                          sx={{ fontFamily: "Oswald,Cairo" }}
                          fontSize={15}
                        >
                          {t("AddUnit.solarelevator")}
                        </Typography>
                      }
                    />
                  </Grid>
                </Grid>
              </FormGroup>
            </Box>
          </Paper>
          <Paper
            elevation={10}
            style={{
              padding: 0,
              borderRadius: 16,
              marginTop: 16,
              direction: t("directions.dir"),
            }}
          >
            <Typography
              variant="h4"
              sx={{
                mt: 2,
                mb: 2,
                boxShadow:
                  "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
                padding: "8px",
                backgroundColor: "#f3efee",
                display: "inline-block",
                width: "auto",
                fontWeight: "bold",
                fontFamily: "oswald,cairo",
                //   right:'0',
                //   position:'absolute'
              }}
            >
              {t("AddUnit.mainimage")}{" "}
              <span
                style={{ color: "red", fontSize: "25px", marginBottom: "-5px" }}
              >
                *
              </span>
            </Typography>

            <Box sx={{ p: 4 }}>
              <Box
                component="label"
                sx={{
                  width: 250,
                  height: 180,
                  border: "1px solid #ddd",
                  borderRadius: 2,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                  backgroundColor: "#fff",
                  overflow: "hidden",
                }}
              >
                {preview ? (
                  <img
                    src={preview}
                    alt="Preview"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <ImageUp size={64} color="black" />
                )}
                <input
                  type="file"
                  accept="image/*"
                  style={{ display: "none" }}
                  ref={fileInputRef}
                  {...register("unit_image", {
                    required: "Image is required",
                  })}
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      setValue("unit_image", file); // مهم جداً لإرسال الصورة
                      setPreview(URL.createObjectURL(file)); // فقط لو حبيت تعرض preview
                    }
                  }}
                />
              </Box>
              {errors["unit_image"] && (
                <Typography variant="h5" color="error">
                  {errors["unit_image"].message}
                </Typography>
              )}
            </Box>
          </Paper>
          <Paper
            elevation={10}
            style={{
              padding: 0,
              borderRadius: 16,
              marginTop: 16,
              direction: t("directions.dir"),
            }}
          >
            <Typography
              variant="h4"
              sx={{
                mt: 2,
                mb: 2,
                boxShadow:
                  "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
                padding: "8px",
                backgroundColor: "#f3efee",
                display: "inline-block",
                width: "auto",
                fontWeight: "bold",
                fontFamily: "oswald,cairo",
                //   right:'0',
                //   position:'absolute'
              }}
            >
              {t("AddUnit.unitplan")}
            </Typography>
            <Box sx={{ p: 4 }}>
              <Box
                {...register("unit-plan")}
                component="label"
                htmlFor="unit-plan"
                sx={{
                  width: 250,
                  height: 180,
                  border: "1px solid #ddd",
                  borderRadius: 2,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                  backgroundColor: "#fff",
                  overflow: "hidden",
                }}
              >
                {preview2 ? (
                  <img
                    src={preview2}
                    alt="Preview"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <ImageUp size={64} color="black" />
                )}
                <input
                  type="file"
                  accept="image/*"
                  id="unit-plan"
                  style={{ display: "none" }}
                  onChange={handleImageUpload2}
                />
              </Box>
            </Box>
          </Paper>

          <Paper
            elevation={10}
            style={{
              padding: 0,
              borderRadius: 16,
              marginTop: 16,
              direction: t("directions.dir"),
            }}
          >
            <Typography
              variant="h4"
              sx={{
                mt: 2,
                mb: 2,
                boxShadow:
                  "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
                padding: "8px",
                backgroundColor: "#f3efee",
                display: "inline-block",
                width: "auto",
                fontWeight: "bold",
                fontFamily: "oswald,cairo",
                //   right:'0',
                //   position:'absolute'
              }}
            >
              {t("AddUnit.unitimages")}{" "}
              <span
                style={{ color: "red", fontSize: "25px", marginBottom: "-5px" }}
              >
                *
              </span>
            </Typography>

            <Typography variant="h6" sx={{ color: "gray", padding: "16px" }}>
              {t("AddUnit.least3")}
            </Typography>
            {previews.length > 0 && (
              <Button
                variant="contained"
                sx={{ ml: "20px" }}
                onClick={() => setPreviews("")}
              >
                Clear
              </Button>
            )}
            <Box sx={{ p: 4 }}>
              <Box
                component="label"
                htmlFor="images"
                sx={{
                  width: "100%",
                  height: 180,
                  border: "1px solid #ddd",
                  borderRadius: 2,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                  backgroundColor: "#fff",
                  overflow: "hidden",
                }}
              >
                {previews.length > 0 ? (
                  <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                    {previews.map((src, index) => (
                      <img
                        key={index}
                        src={src}
                        alt="Previews"
                        style={{
                          width: "30%",
                          height: "180px",
                          objectFit: "cover",
                        }}
                      />
                    ))}
                  </Box>
                ) : (
                  <ImageUp size={64} color="black" />
                )}

                <input
                  type="file"
                  accept="image/*"
                  id="images"
                  multiple
                  style={{ display: "none" }}
                  {...register("images", {
                    onChange: (e) =>
                      handleImageUploads(
                        e,
                        e.target.files && e.target.files.length
                          ? () => {}
                          : () => {}
                      ),
                  })}
                />
              </Box>
              {imageError && <p style={{ color: "red" }}>{imageError}</p>}
              {errors.images && (
                <p style={{ color: "red" }}>{errors.images.message}</p>
              )}
            </Box>
          </Paper>

          <Paper
            elevation={10}
            style={{
              padding: 0,
              borderRadius: 16,
              marginTop: 16,
              direction: t("directions.dir"),
            }}
          >
            <Typography
              variant="h4"
              sx={{
                mt: 2,
                mb: 2,
                boxShadow:
                  "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
                padding: "8px",
                backgroundColor: "#f3efee",
                display: "inline-block",
                width: "auto",
                fontWeight: "bold",
                fontFamily: "oswald,cairo",
                //   right:'0',
                //   position:'absolute'
              }}
            >
              {t("AddUnit.unitvideos")}
            </Typography>

            <Box sx={{ p: 4 }}>
              <Box
                component="label"
                htmlFor="videos"
                sx={{
                  width: "100%",
                  height: 180,
                  border: "1px solid #ddd",
                  borderRadius: 2,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                  backgroundColor: "#fff",
                  overflow: "hidden",
                }}
              >
                {previewsV.length > 0 ? (
                  <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                    {previewsV.map((src, index) => (
                      <video
                        key={index}
                        style={{
                          width: "30%",
                          height: "180px",
                          objectFit: "cover",
                        }}
                        controls
                      >
                        <source src={src} type="video/*" />
                      </video>
                    ))}
                  </Box>
                ) : (
                  <MonitorUp size={64} color="black" />
                )}
                <input
                  {...register("videos")}
                  type="file"
                  accept="video/*"
                  id="videos"
                  multiple
                  style={{ display: "none" }}
                  onChange={handleImageUploadvideo}
                />
              </Box>
              <Grid container>
                <Grid size={10}></Grid>
                <Grid size={2}>
                  <Modall
                    handleOpen={handleOpen}
                    open={open}
                    setOpen={setOpen}
                    handle={handleSubmitt}
                    loading={loading}
                  />
                </Grid>
              </Grid>
            </Box>
          </Paper>
        </Container>
      )}
    </form>
  );
}
